/**
 * Компонент для инициализации глобального notification API для WebSocket handlers
 * 
 * Должен быть размещен внутри AntApp контекста, чтобы иметь доступ к App.useApp()
 */

import { useEffect } from 'react';
import { App } from 'antd';
import { initWebSocketNotificationApi } from '@shared/utils/websocketNotificationApi';

export function WebSocketNotificationInit() {
  const { notification, message } = App.useApp();

  useEffect(() => {
    // Инициализируем глобальный API для WebSocket handlers
    initWebSocketNotificationApi(notification, message);
  }, [notification, message]);

  // Этот компонент ничего не рендерит
  return null;
}
